import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';
import { CreateSaleFromPdvDto } from '../pages/pdv/create-sale-from-pdv-dto';
import { PreVenda, SavePreSaleRequest } from '../models/pre-venda.model';

@Injectable({
  providedIn: 'root'
})
export class PreVendaService {
  private readonly baseUrl = `${environment.base_url}/pre-sales`;

  constructor(private http: HttpClient) {}

  /**
   * Cadastra uma nova pré-venda (salva no backend).
   * Converte o DTO do PDV para o formato esperado pela API (nomes iguais ao backend).
   */
  create(
    dto: CreateSaleFromPdvDto,
    extras?: { cpfCnpj?: string; mobilePhone?: string; employeeId?: number | null }
  ): Observable<RestResponse<PreVenda>> {
    const body: SavePreSaleRequest = {
      cpfCnpj: extras?.cpfCnpj ?? null,
      customerName: dto.customerName || null,
      mobilePhone: extras?.mobilePhone ?? null,
      priceTableId: null,
      discount: dto.discountTotal ?? 0,
      grossTotal: dto.grossTotal ?? 0,
      netTotal: dto.netTotal ?? 0,
      customerId: dto.customerId ?? null,
      sellerId: null,
      saleId: null,
      employeeId: extras?.employeeId ?? dto.employeeId ?? 0,
      items: (dto.items ?? []).map((item) => ({
        productId: item.productId,
        code: item.productCode ?? null,
        barCode: item.productBarCode ?? null,
        description: item.productName ?? null,
        amount: item.amount ?? null,
        price: item.productPrice ?? null,
        costPrice: item.costPrice ?? null,
        total: item.total ?? null
      }))
    };
    return this.http.post<RestResponse<PreVenda>>(`${this.baseUrl}/save`, body);
  }

  /**
   * Lista pré-vendas com busca, período e paginação (mesmo padrão das vendas).
   */
  getAll(
    search: string,
    initialDate: Date,
    finalDate: Date,
    canceled: boolean | null,
    page: number
  ): Observable<RestResponse<PreVenda[]>> {
    const params = {
      search: search ?? '',
      initialDate: initialDate.toISOString(),
      finalDate: finalDate.toISOString(),
      canceled: canceled === null ? '' : String(canceled),
      page: String(page)
    };
    return this.http.get<RestResponse<PreVenda[]>>(`${this.baseUrl}/list`, { params });
  }

  /**
   * Busca uma pré-venda pelo id.
   */
  getById(id: number): Observable<RestResponse<PreVenda>> {
    return this.http.get<RestResponse<PreVenda>>(`${this.baseUrl}/find/${id}`);
  }

  /**
   * Remove uma pré-venda.
   */
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
